import React from "react"
import { BUTTON_VARIANTS, CONTENT_TYPES, ICONS, PADDING } from "@/constants"
import GridContainer from "@/components/common/GridContainer"
import styled from "styled-components"
import { getCssSizeValue, getHtmlFromRedactorField, getItemType, getPaddingsClassFromData } from "@/utils/utils"
import TextWrapper from "@/components/common/StructuredText/common/TextWrapper"
import { useStructuredContext } from "@/components/common/StructuredText"
import dynamic from "next/dynamic"
import Loading from "@/components/common/Loading"
import HeaderDescription from "@/components/common/Header&Description"
import LinkButton from "@/components/common/Buttons/LinkButton"
import DownloadFiles, { DOWNLOAD_FILES_VARIANTS } from "@/components/downloadFiles/DownloadFiles"
import { SingleDownloadBlock } from "@/components/downloadFiles/variants/SingleNewsVariant"
import CommonIcon from "@/components/common/Icon/Icon"
import VideoBlock from "@/components/common/StructuredText/components/Blocks/Video"
import Margin from "@/components/common/Margin"
import SmallImage from "@/components/common/StructuredText/components/Blocks/SmallImage"
import MediumImage from "@/components/common/StructuredText/components/Blocks/MediumImage"
import LargeImage from "@/components/common/StructuredText/components/Blocks/LargeImage"
import Gallery from "@/components/common/StructuredText/components/Blocks/Gallery"
import HighlightHeadingAndDescription from "@/components/common/StructuredText/components/Blocks/HighlightedHeadingAndDescription"
import CancelSubscriptionButton from "@/components/common/StructuredText/components/Blocks/CancelSubscriptionButton"
import Table from "@/components/common/StructuredText/components/Blocks/Table"
import BulletPointsWithActions from "@/components/common/StructuredText/components/Blocks/BulletPointsWithActions"
import CookieButton from "@/components/common/StructuredText/components/Blocks/CookieButton"

// const Margin = dynamic(() => import("@/components/common/Margin"), {
// 	loading: () => <Loading />,
// 	ssr: false,
// })
//
// const Gallery = dynamic(() => import("@/components/common/StructuredText/components/Blocks/Gallery"), {
// 	loading: () => <Loading />,
// 	ssr: false,
// })
//
// const DownloadFiles = dynamic(() => import("@/components/downloadFiles/DownloadFiles"), {
// 	loading: () => <Loading />,
// 	ssr: false,
// })
//
// const SmallImage = dynamic(() => import("@/components/common/StructuredText/components/Blocks/SmallImage"), {
// 	loading: () => <Loading />,
// 	ssr: false,
// })
//
// const MediumImage = dynamic(() => import("@/components/common/StructuredText/components/Blocks/MediumImage"), {
// 	loading: () => <Loading />,
// 	ssr: false,
// })
//
// const LargeImage = dynamic(() => import("@/components/common/StructuredText/components/Blocks/LargeImage"), {
// 	loading: () => <Loading />,
// 	ssr: false,
// })
//
// const HighlightHeadingAndDescription = dynamic(
// 	() => import("@/components/common/StructuredText/components/Blocks/HighlightedHeadingAndDescription"),
// 	{
// 		loading: () => <Loading />,
// 		ssr: false,
// 	},
// )
//
// const Table = dynamic(() => import("@/components/common/StructuredText/components/Blocks/Table"), {
// 	loading: () => <Loading />,
// 	ssr: false,
// })
//
// const BulletPointsWithActions = dynamic(() => import("@/components/common/StructuredText/components/Blocks/BulletPointsWithActions"), {
// 	loading: () => <Loading />,
// 	ssr: false,
// })
//
// const CookieButton = dynamic(() => import("@/components/common/StructuredText/components/Blocks/CookieButton"), {
// 	loading: () => <Loading />,
// 	ssr: false,
// })
//
// const CancelSubscriptionButton = dynamic(() => import("@/components/common/StructuredText/components/Blocks/CancelSubscriptionButton"), {
// 	loading: () => <Loading />,
// 	ssr: false,
// })

export const ImageWrapper = styled.div`
	animation: fade-in 0.75s ease-in-out;

	.image {
		aspect-ratio: ${({ $aspectRatio }) => $aspectRatio || "16/9"};
	}

	&.large-image-container {
		padding-left: var(--paddingX);
		padding-right: var(--paddingX);
	}

	&.variant-author {
		margin-bottom: ${getCssSizeValue(10)};
	}
`

const Icon = styled(CommonIcon)`
	height: 24px;
	width: 24px;
`

const Block = ({ data }) => {
	const indent = useStructuredContext("indent")
	const width = useStructuredContext("width")
	const type = getItemType(data)

	switch (type) {
		case CONTENT_TYPES.MARGIN:
			return <Margin variant={data.margin} />
		case CONTENT_TYPES.DOWNLOAD_FILES:
			return (
				<GridContainer className={`indent-desktop-${indent}`}>
					<TextWrapper className={`col-mobile-8 col-tablet-8 col-desktop-${width}`}>
						<DownloadFiles data={data} variant={DOWNLOAD_FILES_VARIANTS.SINGLE_NEWS} />
					</TextWrapper>
				</GridContainer>
			)
		case CONTENT_TYPES.IMAGE:
			return <SmallImage data={data} />
		case CONTENT_TYPES.MEDIUM_IMAGE:
			return <MediumImage data={data} />
		case CONTENT_TYPES.LARGE_IMAGE:
			return <LargeImage data={data} />
		case CONTENT_TYPES.VIDEO:
			return <VideoBlock data={data} />
		case CONTENT_TYPES.GALLERY:
			return <Gallery data={data} />
		case CONTENT_TYPES.HIGHLIGHTED_HEADING_AND_DESCRIPTION:
			return <HighlightHeadingAndDescription data={data} />
		case CONTENT_TYPES.HEADER_AND_DESCRIPTION_BLOCK:
			return (
				<GridContainer className={`indent-desktop-${indent} indent-tablet-1`}>
					<HeaderDescription data={data} className={`col-mobile-8 col-tablet-5 col-desktop-${width}`} />
				</GridContainer>
			)
		case CONTENT_TYPES.HEADER_AND_DESCRIPTION_TIGHT_BLOCK:
			return (
				<GridContainer className={`indent-desktop-${indent} indent-tablet-1`}>
					<HeaderDescription data={data} className={`col-mobile-8 col-tablet-5 col-desktop-${width}`} />
				</GridContainer>
			)
		case CONTENT_TYPES.HEADER_AND_DESCRIPTION_TWO_COLUMN_BLOCK:
			return (
				<GridContainer className={`indent-desktop-${indent}`}>
					<HeaderDescription data={data} className={`col-desktop-${width}`} />
				</GridContainer>
			)
		case CONTENT_TYPES.HEADER_DESCRIPTION_AND_AUDIO_BLOCK:
			return (
				<GridContainer className={`indent-desktop-${indent}`}>
					<HeaderDescription data={data} className={`col-desktop-${width}`} />
				</GridContainer>
			)
		case CONTENT_TYPES.BUTTON: {
			const paddings = getPaddingsClassFromData({
				paddings: {
					top: PADDING.EXTRA_SMALL,
					bottom: PADDING.EXTRA_SMALL,
				},
			})
			return (
				<GridContainer className={`indent-desktop-${indent} ${paddings}`}>
					<LinkButton data={data} variant={BUTTON_VARIANTS.TERTIARY} className={`col-desktop-${width}`} />
				</GridContainer>
			)
		}
		case CONTENT_TYPES.ARROW_BUTTON: {
			const paddingsArrow = getPaddingsClassFromData({
				paddings: {
					top: PADDING.EXTRA_SMALL,
					bottom: PADDING.EXTRA_SMALL,
				},
			})
			return (
				<GridContainer className={`indent-desktop-${indent} ${paddingsArrow}`}>
					<LinkButton data={data} variant={BUTTON_VARIANTS.PRIMARY} className={`col-desktop-${width}`}>
						<Icon name={ICONS.ARROW_RIGHT} />
					</LinkButton>
				</GridContainer>
			)
		}
		case CONTENT_TYPES.CANCEL_SUBSCRIPTION_BUTTON_BLOCK:
			return (
				<GridContainer className={`indent-desktop-${indent}`}>
					<CancelSubscriptionButton data={data} width={width} />
				</GridContainer>
			)
		case CONTENT_TYPES.ASSET_BLOCK: {
			const text = getHtmlFromRedactorField(data?.text || "")
			const assetUrl = data?.asset?.url || ""

			return (
				<GridContainer className={`indent-desktop-${indent}`}>
					<TextWrapper className={`col-mobile-8 col-tablet-8 col-desktop-${width}`}>
						<SingleDownloadBlock fileName={text} fileUrl={assetUrl} asRedactor gap />
					</TextWrapper>
				</GridContainer>
			)
		}
		case CONTENT_TYPES.TABLE_BLOCK:
			return <Table data={data} />
		case CONTENT_TYPES.BULLET_POINTS_WITH_ACTIONS_BLOCK:
			return <BulletPointsWithActions data={data} />
		case CONTENT_TYPES.COOKIES_BUTTON_BLOCK:
			return (
				<GridContainer className={`indent-desktop-${indent}`}>
					<CookieButton data={data} />
				</GridContainer>
			)
		default:
			return null
	}
}

export default Block